import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from '../../_models/user';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.css']
})
export class NotificationSettingsComponent implements OnInit {
  notificationsList: any;

  constructor(private api: ApiIntegration, public user: User, private alertService: AlertService, private http: HttpClient, private g: Globals) {
    this.g.page = "Notification Settings";
    this.getlist();
  }

  ngOnInit() {
  }

  getlist() {
    this.g.loaderDisplay = "display";
    this.api.getAllNotificationTypesList("1", "ALL").subscribe((data: any) => {
      this.g.loaderDisplay = "";

      this.notificationsList = data.types;
      this.notificationsList.forEach((notification) => {
        notification.notificationTypes.forEach((n) => {
          if (n.status === 'ACTIVE') {
            n.enabled = true;
          } else {
            n.enabled = false;
          }
        });
      });
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  changeStatus(c, id) {
    let api = "";
    this.g.loaderDisplay = "display";
    if (c.enabled) {
      api = 'api/deActivateNotification';
      c.status = "IN_ACTIVE";
    } else {
      api = 'api/activateNotification';
      c.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + api, {
      "id": c.displayPriority,
      "organizationId": this.user.organizationId,
      "status": c.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.getlist();
          this.alertService.success('Notification', 'Status Updated Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  updateStatus(n, id) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateNotificationTypes', {
      "id": n.displayPriority,
      "notificationMode": n.notificationMode,
      "organizationId": this.user.organizationId,
      "status": n.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.getlist();
          this.alertService.success();
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
